import { render, staticRenderFns } from "./plan-item.vue?vue&type=template&id=762d8332&scoped=true"
import script from "./plan-item.vue?vue&type=script&lang=js"
export * from "./plan-item.vue?vue&type=script&lang=js"
import style0 from "./plan-item.vue?vue&type=style&index=0&id=762d8332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d8332",
  null
  
)

export default component.exports